import { Deserializable } from '../deserializable';
import {LoaiPhong} from './loaiphong';
import {Staffs} from '../staff/staffs';


export  class DonVi implements Deserializable
{
  public  id: number;
  public  tenCQ: string;
  public  tenVietTat: string;
  public  cap: number;
  public  maCapTren: number;
  public  stt: number;
  public  suDung: number;
  public  hasChild: boolean;


  deserialize(input: any): this {
    Object.assign(this, input);
    //this.staffs = input.staffs.map(staff => new Staffs().deserialize(staff));
    return this;
  }
}
